<template>
  <div class="manage-users page-wrapper">
    <div class="loader text-center mt-5" v-show="loading">
      <circle-loader :size="45"></circle-loader>
    </div>
    <div class="users-content" v-show="!loading">
      <h3>Users</h3>
      <div class="mb-3">
        <b-button variant="primary" @click="$bvModal.show('add-user-modal')">
          Add User
        </b-button>
      </div>
      <div class="text-center" v-if="users.length == 0">- no users -</div>
      <div class="" v-if="users.length > 0">
        <user-list
          :users="users"
          @user-updated="handleUserUpdated"
          @user-deleted="handleUserDeleted"
        ></user-list>
      </div>
    </div>
    <b-modal size="xl" id="add-user-modal" title="Add User" hide-footer>
      <add-user-page @user-created="handleUserCreated"></add-user-page>
    </b-modal>
  </div>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { userStore } from '@/stores/userStore'
import CircleLoader from '@/components/CircleLoader.vue'
import UserList from '@/components/UserList.vue'
import AddUserPage from '@/views/AddUserPage.vue'

export default {
  name: 'ManageUsersPage',
  components: { CircleLoader, UserList, AddUserPage },
  inject: {
    userStore,
  },
  data: function () {
    return {
      loading: true,
      users: [],
    }
  },
  methods: {
    getUsers() {
      return axios
        .get('/services/v2/users')
        .then(response => {
          this.users = response.data.users
        })
        .catch(err => {
          console.log('err', err)
          this.$toasted.error('Error loading users', {
            duration: 4000,
          })
        })
    },
    handleUserCreated(user) {
      // Refresh the user list
      this.getUsers()
    },
    handleUserUpdated(updatedUser) {
      // Find and update the user in the list
      const index = this.users.findIndex(u => u._id === updatedUser._id)
      if (index !== -1) {
        this.$set(this.users, index, updatedUser)
      }
    },
    handleUserDeleted(userId) {
      // Remove the user from the list
      this.users = this.users.filter(u => u._id !== userId)
    },
  },
  mounted() {
    return Promise.all([this.getUsers()]).then(responses => {
      this.loading = false
    })
  },
}
</script>

<style lang="scss" scoped>
.manage-users {
  padding: 20px;
}
</style>


